// extracted by mini-css-extract-plugin
module.exports = {"Stories":"Stories_Stories__2UQnb","Scroll-arrow":"Stories_Scroll-arrow__YpqSy","Left-arrow":"Stories_Left-arrow__1nYVw","Right-arrow":"Stories_Right-arrow__2vPwU"};